import { Alert, AlertContent, AlertTitle, Spinner } from '@zrsystem/ui';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/app/providers/auth-provider.js';
import { appPaths } from '@/app/router/paths.js';
import { useWorkspace } from '@/app/workspace/use-workspace.js';

interface RequirePlaceProps {
  children: ReactNode;
}

export function RequirePlace({ children }: RequirePlaceProps) {
  const { status } = useAuth();
  const { isReady, places } = useWorkspace();

  if (status === 'loading' || !isReady) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <Spinner aria-label="Carregando workspace" />
      </div>
    );
  }

  if (places.length === 0) {
    return (
      <div style={{ maxWidth: 480, margin: '4rem auto', padding: '0 1rem' }}>
        <Alert variant="warning">
          <AlertContent>
            <AlertTitle>Nenhuma unidade disponível</AlertTitle>
            Entre em contato com o administrador para vincular uma unidade à sua conta.
          </AlertContent>
        </Alert>
      </div>
    );
  }

  return children;
}

export function RedirectIfAuthenticated({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <Spinner aria-label="Carregando sessão" />
      </div>
    );
  }

  if (status === 'authenticated') {
    return <Navigate to={appPaths.home} replace />;
  }

  return children;
}
